import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import {
  DefaultIKeyValPairAndInputStateModel,
  IKeyValPair,
  IKeyValPairAndInputStateModel,
} from '../../../../models/StateModels';

export default ApiBaseReducer<pList, IKeyValPairAndInputStateModel<pList>, IKeyValPair>(
  ActionSubTypes.API_GAYRIMENKULSAYI,
  DefaultIKeyValPairAndInputStateModel<pList>()
);
